import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Paper, Grid, Typography, ButtonGroup, Button } from '@mui/material';
import {
    defaultEventsLoad, setSelectedAssetId, removeSelectedAssetId,
    setViewType
} from '../../features/events/eventsSlice';
import { setMapControl } from '../../features/map/mapSlice';
import EventSearchBox from './EventSearchBox'

import Icon from '@mdi/react';
import {
    mdiBookSearch, mdiHours24,
} from '@mdi/js';

import VehicleAutoComplete from '../common/VehicleAutoComplete';

const EventBarTop = () => {
    const dispatch = useDispatch();
    const [searchModalOpen, setSearchModalOpen] = useState(false);
    const [vehicle, setVehicle] = useState("");
    const [assetId, setAssetId] = useState("");

    const handleSearchModalOpen = () => {
        vehicleDeselect();
        setSearchModalOpen(true);
    };
    const handleSearchModalClose = () => {
        setSearchModalOpen(false);
    }

    useEffect(() => {
        dispatch(setViewType('default'));
        /*dispatch(defaultEventsLoad({
            hours: 6
        }));*/
        dispatch(setMapControl('event'));
    }, [dispatch]);


    const last24Hourevents = () => {
        //vehicleDeselect();
        dispatch(setViewType('default'));
        dispatch(defaultEventsLoad({
            days: 1
        }));
    }


    const onVehicleSelect = (e, newValue) => {
        setVehicle(newValue);
    }

    const vehicleDeselect = () => {
        setVehicle("");
        dispatch(removeSelectedAssetId());
    }

    const onAssetIdChange = (e, newValue) => {
        setAssetId(newValue);
        if (newValue) {
            dispatch(setSelectedAssetId(newValue));
        } else {
            //console.log("removing selected asset");
            dispatch(removeSelectedAssetId());
        }
    }
    return (
        <Paper>
            <div style={{
                marginLeft: '15px',
            }}>
                <Grid container spacing={1}>
                    <Grid item sm={12}>
                        <Typography variant="h6">
                            <b>Vehicle Events</b>
                        </Typography>
                    </Grid>
                    <Grid item sm={12}>
                        <VehicleAutoComplete
                            vehicle={vehicle}
                            onVehicleSelect={onVehicleSelect}
                            assetId={assetId}
                            onAssetIdChange={onAssetIdChange}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <ButtonGroup color="primary" variant="outlined" size="small">
                            <Button
                                onClick={last24Hourevents}
                                size="small"
                                startIcon={
                                    <Icon path={mdiHours24}
                                        title="24 Hours"
                                        size={0.9}
                                        color="SlateBlue"
                                    />
                                }
                            >
                                Last 24 Hours
                            </Button>
                            <Button
                                onClick={handleSearchModalOpen}
                                size="small"
                                endIcon={
                                    <Icon path={mdiBookSearch}
                                        title="Search"
                                        size={0.9}
                                        color="Tomato"
                                    />
                                }
                            >
                                Search
                            </Button>
                        </ButtonGroup>
                    </Grid>
                    <Grid item>
                        <div style={{ height: '5px' }}></div>
                    </Grid>
                </Grid>
            </div>
            <EventSearchBox
                searchModalOpen={searchModalOpen}
                handleSearchModalClose={handleSearchModalClose}
            />
        </Paper>
    );
}

export default EventBarTop;